import { render, staticRenderFns } from "./Tarja.vue?vue&type=template&id=844cbf9c&scoped=true&"
import script from "./Tarja.vue?vue&type=script&lang=js&"
export * from "./Tarja.vue?vue&type=script&lang=js&"
import style0 from "./Tarja.vue?vue&type=style&index=0&id=844cbf9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844cbf9c",
  null
  
)

export default component.exports